import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Accordion as StyledAccordion, Button, Text } from './styles';
import Card from '../Card';

function Skeleton({ width = '100%', height = '16px', style = {} }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: 4,
        backgroundColor: '#e0e0e0',
        ...style,
      }}
    />
  );
}

export default function AccordionComponent({
  title,
  children,
  closedText = 'Visualizar',
  closeButtonText = 'Fechar',
  loading = false,
  buttonLoading = false,
  buttonProps = { variant: 'primary', outlined: true },
  cardProps,
  trigger = () => {},
  ...props
}) {
  const [isClosed, setIsClosed] = useState(true);

  return (
    <StyledAccordion {...props}>
      <Card
        {...cardProps}
        header={
          <>
            {loading ? (
              <Skeleton width="120px" height="20px" />
            ) : (
              <Text>{title}</Text>
            )}

            <Button
              loading={buttonLoading}
              onClick={() => {
                setIsClosed(!isClosed);
                if (isClosed) trigger();
              }}
              {...buttonProps}
            >
              {isClosed ? closedText : closeButtonText}
            </Button>
          </>
        }
      >
        <Collapse in={!isClosed}>
          <div>
            {loading ? (
              <>
                <Skeleton
                  width="100%"
                  height="15px"
                  style={{ marginBottom: '8px' }}
                />
                <Skeleton
                  width="90%"
                  height="15px"
                  style={{ marginBottom: '8px' }}
                />
                <Skeleton width="95%" height="15px" />
              </>
            ) : (
              children
            )}
          </div>
        </Collapse>
      </Card>
    </StyledAccordion>
  );
}
